const leaveArrayOnlyWithKeys = (arr: string[], keys: string[]) => {
  return arr.filter((item) => keys.includes(item));
};

export { leaveArrayOnlyWithKeys };
